
import { Component, Vue } from "vue-property-decorator";
import { CartItemCode } from "@/types/cart-item";
import { namespace } from "vuex-class";
import CartCategory from "@/views/_components/CartCategory.vue";
import { Cart } from "@/types/Cart";
import Disclaimer from "@/views/pages/misc/Disclaimer.vue";
import CategoriesMobile from "@/views/_components/mobile/CategoriesMobile.vue";
import Loader from "@/components/Loader.vue";

const { State } = namespace("Root");

@Component({
  components: {
    CartCategory,
    Disclaimer,
    CategoriesMobile,
    Loader,
  },
})
export default class WizardHomeLayout extends Vue {
  @State("cart") cart!: Cart;

  contunueHTML = "&nbsp;";
  loading = false;
  iPhone = CartItemCode.iphone.code;
  iPad = CartItemCode.ipad.code;
  laptop = CartItemCode.laptop.code;
  smartphone = CartItemCode.smartphone.code;
  gamingSystem = CartItemCode.gamingsystem.code;
  camera = CartItemCode.camera.code;
  appleWatch = CartItemCode.applewatch.code;
  smartwatch = CartItemCode.smartwatch.code;
  eReader = CartItemCode.ereader.code;
  tablet = CartItemCode.tablet.code;

  async created() {
    this.cart.clearIfCompleted();
  }

  showDisclaimer() {
    let modal = this.$refs.disclaimer as any;
    if (modal) {
      modal.show();
    }
  }
}
